import React, { useState } from 'react';
import {
  Box,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  TextField,
  Tooltip,
  CircularProgress,
} from '@mui/material';
import PropTypes from 'prop-types';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import SERVER_API_URL from '../../../config';
import axiosInstance from '../../../api';

export default function UploadFile({
  user,
  targetType,
  targetId
}) {
  const [open, setOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setOpen(true);
  };

  const handleUploadFile = async () => {
    if (!selectedFile) {
      alert('እባክዎ ሰነዱን በድጋሜ ይምረጡ።');
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append('body', body || " ");
      formData.append('targetType', targetType);
      formData.append('targetId', targetId);

      const response = await axiosInstance.post(
        `${SERVER_API_URL}/chatFile/uploadFile/${user?.id}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.status === 201) {
        setOpen(false);
        setSelectedFile(null);
        setBody('');
      }
    } catch (error) {
      // console.log(error);
    }
    setLoading(false);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', px: 2 }}>
      <Dialog open={open} onClose={() => setOpen(false)} >
        <Box sx={{ backgroundColor: (theme) => theme.palette.mode === 'light' ? '#F9F9FB' : '#272424' }}>
          <DialogContent >
            <DialogContentText sx={{ py: 2 }}>
              {selectedFile?.name} የሚል ፋይል መርጠሃል ፣ ለማረጋገጥ "ጫን" የሚለውን ተጫን።
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              label="መግለጫ ጽሑፍ (አማራጭ)"
              type="text"
              fullWidth
              multiline
              maxRows={3}
              placeholder='ስለ ሰነዱ አጭር መግለጫ ጽሑፍ...'
              variant="outlined"
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>ተመለስ</Button>

            {!loading && (<Button color="primary" variant="contained" onClick={handleUploadFile}>
              ላክ
            </Button>
            )}
            {loading && (
              <Button variant="contained" color="primary" sx={{ minWidth: { xs: 80, sm: 150 } }} disabled>
                <CircularProgress style={{ width: '20px', height: '20px' }} />
                በመላክ ላይ ...
              </Button>
            )}
          </DialogActions>
        </Box>
      </Dialog>
      <Tooltip title="ሰነድ ላክ">
        <IconButton component="label" variant="outlined" color="darkgray">
          <AddCircleOutlineIcon />
          <input type="file" hidden onChange={handleFileChange} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

UploadFile.propTypes = {
  user: PropTypes.object.isRequired,
  targetType: PropTypes.string.isRequired,
  targetId: PropTypes.string.isRequired,
};

